// Option 6: Badge Style Logo - Circular DH badge with stacked text
export const Logo = ({ className = "", variant = "default", size = "default" }) => {
  const isWhite = variant === "white";
  const primaryColor = "#366FED"; // Blue
  const textColor = isWhite ? "#FFFFFF" : "#000080"; // Navy or white
  
  // Size variants - responsive
  const sizeClasses = {
    small: { 
      badge: "w-8 h-8 sm:w-10 sm:h-10", 
      badgeText: "text-xs sm:text-sm", 
      title: "text-base sm:text-lg", 
      subtitle: "text-[10px] sm:text-xs" 
    },
    default: { 
      badge: "w-10 h-10 sm:w-12 sm:h-12", 
      badgeText: "text-sm sm:text-lg", 
      title: "text-lg sm:text-xl", 
      subtitle: "text-xs sm:text-sm" 
    },
    large: { 
      badge: "w-12 h-12 sm:w-16 sm:h-16", 
      badgeText: "text-base sm:text-xl", 
      title: "text-xl sm:text-2xl", 
      subtitle: "text-sm sm:text-base" 
    },
  };
  
  const sizes = sizeClasses[size] || sizeClasses.default;
  
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo">
      {/* Circular Badge */}
      <div 
        className={`${sizes.badge} rounded-full bg-primary flex items-center justify-center flex-shrink-0`}
        style={{ backgroundColor: primaryColor }}
      >
        <span className={`text-white font-bold ${sizes.badgeText}`}>DH</span>
      </div>
      
      {/* Stacked Text */}
      <div className="flex flex-col leading-tight">
        <span 
          className={`${sizes.title} font-bold font-['Manrope'] leading-tight`}
          style={{ color: textColor }}
        >
          Digitive
        </span>
        <span 
          className={`${sizes.subtitle} font-medium leading-tight`}
          style={{ color: primaryColor }}
        >
          Health
        </span>
      </div>
    </div>
  );
};

// Icon-only version of the logo
export const LogoIcon = ({ className = "", size = 40 }) => {
  return (
    <div 
      className={`rounded-full bg-primary flex items-center justify-center ${className}`}
      style={{ 
        width: size, 
        height: size, 
        backgroundColor: "#366FED" 
      }}
    >
      <span 
        className="text-white font-bold"
        style={{ fontSize: size * 0.4 }}
      >
        DH
      </span>
    </div>
  );
};

export default Logo;
